import { Component, OnInit, Input } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalApproveComponent } from './modal-approve/modal-approve.component';
import { ModalRejectComponent } from './modal-reject/modal-reject.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccessService } from '../service/access.service';
import { ModalTermsAcceptRequestComponent } from './modal-terms-accept-request/modal-terms-accept-request.component';

import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-access-incoming-request-details',
  templateUrl: './access-incoming-request-details.component.html',
  styleUrls: ['./access-incoming-request-details.component.css']
})
export class AccessIncomingRequestDetailsComponent implements OnInit {
  @Input() id: string;
  formAccessContractor: UntypedFormGroup;
  formBle: UntypedFormGroup;
  Approvers: any;
  status: any = [];
  SeeItems: any = [];
  people: any = [];
  type: any = [];
  approvedAccess: any = false;
  submited = false;
  qualificationDummy: any = [];
  lang: string;
  statusFacility: number;
  dateValn=false;
  OneDayValidation=false;


  options:any[];
  hasRestrictedPerson = false;


  constructor(public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    private dataApi: AccessService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router) {
    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');

  }

  public toFormControl(point: AbstractControl): UntypedFormControl {
    return point as UntypedFormControl;
   }
  dateValidation(dateStart,dataEnd )
  {
    this.dateValn=false;
    const startDate  = new Date(this.datePipe.transform(dateStart, "MM/dd/yyyy"));
    const endDate    = new Date(this.datePipe.transform(dataEnd, "MM/dd/yyyy"));
    var Difference_In_Time = endDate.getTime() - startDate.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    if (Difference_In_Days >= 30)
    {
      this.dateValn=true;
    }else{
      this.dateValn=false;
      if(Difference_In_Days >1)
      {
         this.OneDayValidation=true;
      }
    }
  }

  ngOnInit() {

    this.formAccessContractor = this.formBuilder.group({
      Confirm: [false, Validators.required]
    });
    this.formBle = this.formBuilder.group({
      approverDelegate: ['', Validators.required]

    })

    this.spinner.show("AccessValidation")
    this.dataApi.getValidatePermision().subscribe(
      (data: any)=>{
        this.spinner.hide("AccessValidation");
        if(data) {
          this.getAccessDetail()
        }
        else{

          //sessionStorage.clear();
          //this.router.navigate(['/404']);
          //window.location.reload();
         }
      },
      (err)=>{

        this.spinner.hide("AccessValidation");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',

          });
        }
      }
    )


    //this.getAccessDetail();
  }

  openDialog() {
    this.dialog.open(ModalTermsAcceptRequestComponent, { panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formAccessContractor.controls['Confirm'].setValue(true);
      }
    });
  }

  openDialogAccept() {
    if (this.formAccessContractor.controls['Confirm'].hasError('required')) {
      this.submited = true;
      return;
    }
    this.dialog.open(ModalApproveComponent,
      { panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
        if (accept) {

          this.statusFacility = null;
          //normal workflow
          if ((this.status.Name === 'Pending' || this.status.Name === 'Delegate') && this.SeeItems.facilityEnabled === false) {
            this.statusFacility = 2;
          }
          //facilityPriority true
          if (this.status.Name === 'Pending by Facility') {
            if (this.SeeItems.facilityPriority === 'True') {
              //5 .-Pending by SAR Approver
              this.statusFacility = 5;
            } else if (this.SeeItems.facilityPriority === 'False') {
              //8 .-Approved by Facilities
              this.statusFacility = 8;
            }
          }
          //facilityPriority flase
          if (this.status.Name === 'Pending by SAR Approver') {
            if (this.SeeItems.facilityPriority === 'True') {
              //7.- Approved by SAR Approver
              this.statusFacility = 7;

            } else if (this.SeeItems.facilityPriority === 'False') {
              //6.- Pending by Facility
              this.statusFacility = 6;
            }
          }

          this.spinner.show("loading");
          this.dataApi.ChangeStatusAccess(this.id, this.statusFacility).subscribe(() => {
            this.spinner.hide("loading");
            this.router.navigate(['/incoming-access-confirmation/' + this.id])
          }, (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          });
        }
      });
  }

  openDialogReject() {
    if (this.formAccessContractor.controls['Confirm'].hasError('required')) {
      this.submited = true;
      return;
    }
    this.dialog.open(ModalRejectComponent,
      { panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
        if (accept) {
          this.statusFacility = null;
          //normal workflow
          if (this.status.Name === 'Pending' && this.SeeItems.facilityEnabled === false) {
            this.statusFacility = 3;
          }
          //facilityPriority true
          if (this.status.Name === 'Pending by Facility') {
            //10.- Rejected by Facilities
            this.statusFacility = 10;
          }
          //facilityPriority
          if (this.status.Name === 'Pending by SAR Approver') {
            //9.-Rejected by SAR Approver
            this.statusFacility = 9;

          }
          this.spinner.show("loading");
          this.dataApi.ChangeStatusAccess(this.id, this.statusFacility).subscribe(() => {
            this.spinner.hide("loading");
            this.router.navigate(['/incoming-access-confirmation/' + this.id])
          }, (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          });
        }
      });
  }

  // openDialogTerminate() {
  //   if (this.formAccessContractor.controls['Confirm'].hasError('required')) {
  //     this.submited = true;
  //     return;
  //   }
  //   const dialogRef = this.dialog.open(ModalTerminateComponent, {
  //     width: 'auto',
  //     panelClass: 'myapp-no-padding-dialog',
  //     data: {
  //       id: this.id
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe((option) => {

  //     if(option){
  //       this.router.navigate(['/incoming-access-confirmation/' + this.id]);
  //     }
  //   });

  // }
  filteredOptions: Observable<any>;
  private _filter(name: string): any[] {
  const filterValue = name.toLowerCase();
  const devolver = this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    return  devolver;
  }
  displayFn(user: any): string {
    return user.mdmid && user.name ? user.name : '';
  }
  getAccessDetail() {
    this.spinner.show("loading")
    this.dataApi.getAccessDetail(this.id).subscribe((data: any) => {
      this.lang = sessionStorage.getItem('lang')
      this.qualificationDummy = data.qualificationDummy;
      this.SeeItems = data;
      this.Approvers = data.approvers;

      this.options= this.Approvers.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);;
      this.filteredOptions = this.formBle.controls.approverDelegate.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );




      this.type = data.type;
      this.status = data.status;
      this.people = data.people;

      this.approvedAccess = data.approvedAccess;

      this.dateValidation(this.SeeItems.periodFrom ,this.SeeItems.periodTo );

      this.hasRestrictedPerson = this.people.filter(item => item.isRestrictedPerson).length > 0;

      this.spinner.hide("loading")
    },
      (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',

          });
        }
      });
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }


  delegate() {
    // if (this.formBle.invalid) {
    //   return;
    // }

    if ((this.formBle.controls['approverDelegate'].value.mdmid==='' || this.formBle.controls['approverDelegate'].value.mdmid===undefined || this.formBle.controls['approverDelegate'].value.mdmid===null))
    {
      return;
    }
    this.spinner.show("loading")
    this.dataApi.patchApproverDetails(this.id, this.formBle.value.approverDelegate.mdmid, 4).subscribe(
      (data: any) => {
        this.spinner.hide("loading")
        this.router.navigate(['/incoming-access-requests/']);
        this.spinner.hide("uploading");

      }, (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',

          });
        }
      });



  }

}
